module.exports = __webpack_public_path__ + "img/progress-4.04043c2d.png";